import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generateTimeSlots(
  start: string,
  end: string,
  interval: number,
) {
  const slots = [];
  let current = new Date(`1970-01-01T${start}:00`);
  const endTime = new Date(`1970-01-01T${end}:00`);

  while (current <= endTime) {
    const hours = current.getHours().toString().padStart(2, "0");
    const minutes = current.getMinutes().toString().padStart(2, "0");

    slots.push(`${hours}:${minutes}`);

    current.setMinutes(current.getMinutes() + interval);
  }

  return slots;
}

// export function formatZoomStartTime({
//   date,
//   time,
// }: {
//   date: Date;
//   time: string;
// }) {
//   const [hours, minutes] = time.split(":").map(Number);

//   const meetingDate = new Date(date);

//   meetingDate.setHours(hours);
//   meetingDate.setMinutes(minutes);
//   meetingDate.setSeconds(0);
//   meetingDate.setMilliseconds(0);

//   const year = meetingDate.getFullYear();
//   const month = String(meetingDate.getMonth() + 1).padStart(2, "0");
//   const day = String(meetingDate.getDate()).padStart(2, "0");
//   const h = String(meetingDate.getHours()).padStart(2, "0");
//   const m = String(meetingDate.getMinutes()).padStart(2, "0");

//   return `${year}-${month}-${day}T${h}:${m}:00`;
// }

export function formatMeetingTimeRange(time: string, duration = 30) {
  const [hours, minutes] = time.split(":").map(Number);

  const start = new Date();
  start.setHours(hours);
  start.setMinutes(minutes);
  start.setSeconds(0);

  const end = new Date(start);
  end.setMinutes(end.getMinutes() + duration);

  const format = (date: Date) =>
    date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: false,
    });

  return `${format(start)} - ${format(end)}`;
}
